__turbopack_context__.v({
  "bar": "StickyActions-module-scss-module__M6FCUG__bar",
});
